export default {"src":"/_next/static/media/tips_red.55430ce6.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};